import { render, staticRenderFns } from "./my-cascader.vue?vue&type=template&id=85f691da&"
import script from "./my-cascader.vue?vue&type=script&lang=js&"
export * from "./my-cascader.vue?vue&type=script&lang=js&"
import style0 from "./my-cascader.vue?vue&type=style&index=0&id=85f691da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports